











































































import { Simulation } from "@/api/coverageAnalysis";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import CoverageAnalysesItem from "@/components/Molecules/CoverageAnalysesItem/index.vue";
import CoverageAnalysesResult from "@/components/Molecules/CoverageAnalysesResult/index.vue";
import RadioGroupModal from "@/components/Molecules/RadioGroupModal/index.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { defineComponent, ref } from "vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default defineComponent({
  components: {
    RadioGroupModal,
    FixedButtonRow,
    CoverageAnalysesItem,
    CoverageAnalysesResult
  },
  data() {
    return {
      prevRouteName: "",
      modalRequerDutTexts: [
        "1. Este serviço tem como objetivo informar se o exame consultado possui cobertura pelo seu contrato e se há necessidade de Autorização Prévia para sua realização na Rede Credenciada.",
        "2. Caso você esteja em período de Carência para Exames ou possua CPT (Cobertura Parcial Temporária), será necessário aguardar o término desse prazo para realizar os exames.",
        '3. Exames identificados com "Avaliação necessária" ou que exijam Autorização Prévia devem ser enviados para avaliação da equipe médica Omint, por meio da opção "Solicitar Autorização".'
      ]
    };
  },
  setup() {
    const showSortModal = ref(false);
    const showRequerDutModal = ref(false);
    return {
      showSortModal,
      showRequerDutModal
    };
  },
  beforeRouteEnter(_, from, next) {
    next((vm: any) => {
      const name = from && from.name ? String(from.name) : "";
      vm.prevRouteName = name;
    });
  },
  async mounted() {
    this.$root.$emit("show-loading");
    const fromCoverageFlow = !!this.prevRouteName && String(this.prevRouteName).startsWith("analise_cobertura");
    if (!fromCoverageFlow) {
      this.SET_SIMULATIONS_SORT_OPTION("");
    }
    await this.validateLimit();

    const result = await this.fetchSimulations();
    if (!result) {
      Swal.fire({
        icon: "error",
        text: "Não foi possível carregar a lista de exames",
        confirmButtonText: "OK"
      });
    }
    this.SET_SEARCH_EXAMS([]);
    this.SET_SELECTED_EXAMS([]);
    this.SET_SEARCH_LABS([]);

    this.$root.$emit("hide-loading");
  },
  computed: {
    ...mapState("auths", ["newAuthSuccess"]),
    ...mapState("coverageAnalysis", ["authorized", "simulations", "searchExams", "simulationsSortOption"]),
    authorizedState(): boolean {
      return this.authorized;
    },
    activeSort: {
      get(): string {
        return this.simulationsSortOption || "";
      },
      set(value: string) {
        this.SET_SIMULATIONS_SORT_OPTION(value || "");
      }
    },
    items(): Simulation[] {
      return this.simulations;
    },
    sortedItems(): Simulation[] {
      const list: Simulation[] = this.items || [];
      const opt = (this.activeSort || "").trim();
      if (!opt) return list;

      const parseBrDate = (dateStr: string): Date | null => {
        if (!dateStr || typeof dateStr !== "string") return null;
        const parts = dateStr.split("/");
        if (parts.length !== 3) return null;
        const d = Number.parseInt(parts[0], 10);
        const m = Number.parseInt(parts[1], 10);
        const y = Number.parseInt(parts[2], 10);
        if (!d || !m || !y) return null;
        return new Date(y, m - 1, d);
      };

      const withDates = list
        .map(s => ({ s, dt: parseBrDate(s.SalvoEm) }))
        .filter(x => x.dt instanceof Date && !Number.isNaN(x.dt!.getTime()));
      const withoutDates = list.filter(s => !withDates.some(x => x.s === s));

      if (opt === "Ultimos 30 dias") {
        const now = new Date();
        const cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);
        return withDates
          .filter(x => x.dt! >= cutoff)
          .sort((a, b) => b.dt!.getTime() - a.dt!.getTime())
          .map(x => x.s);
      }

      if (opt === "Mais recente") {
        return [...withDates.sort((a, b) => b.dt!.getTime() - a.dt!.getTime()).map(x => x.s), ...withoutDates];
      }

      if (opt === "Mais antigo") {
        return [...withDates.sort((a, b) => a.dt!.getTime() - b.dt!.getTime()).map(x => x.s), ...withoutDates];
      }

      return list;
    }
  },
  methods: {
    ...mapActions("coverageAnalysis", ["validateLimit", "fetchSimulations"]),
    ...mapMutations("coverageAnalysis", [
      "SET_SEARCH_EXAMS",
      "SET_SELECTED_EXAMS",
      "SET_SEARCH_LABS",
      "SET_SIMULATIONS_SORT_OPTION"
    ]),
    handleRedirectToNewAnalysis() {
      this.showRequerDutModal = false;
      this.$router.push({
        name: "analise_cobertura.nova_analise"
      });
    },
    handleShowRequerDutModal() {
      this.showRequerDutModal = true;
    }
  }
});
